<template>
    <div class="row align-items-end">
        <div class="col-xl-3 col-md-4 col-sm-6">
            {{ $t('modal.form.driver.label') }}
            <v-select
                class="filter-select"
                v-model="pagination.driver_id"
                :options="driver.filter"
                :reduce="(options) => options.id"
                @input="fetchData(), fetchActiveRound()"
                label="full_name"
            ></v-select>
        </div>
        <div class="col-xl-3 col-md-4 col-md-4">
            <input
                class="filter-input"
                v-model="pagination.date"
                type="date"
                :max="nowDate()"
                @input="fetchData"
            >
        </div>
        <div class="col-xl-3 col-md-4 col- col-sm-6" v-if="pagination.driver_id">
            <p class="fs-4 mb-0">{{ $t('data.driverWaterCount') }}: <b>{{ round.isHave }}</b></p>
        </div>

        <div class="col-xl-3 col-md-4 col- col-sm-6 h-auto ms-auto">
            <div class="w-100 d-flex justify-content-end">
                <b-button
                    variant="primary"
                    @click="actionModalPost"
                >
                    {{ $t('modal.nameModalPost') }}
                </b-button>
            </div>
        </div>
        <div class="col-12">
            <div class="_table">
                <b-table
                    :fields="fields"
                    :items="fetch.items"
                    :busy="fetch.loading"
                    :tbody-tr-class="tableRow"
                >
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template #cell(created_at)="{item}">
                        <span>
                          {{ item.created_at | momentDate(item.created_at) }}
                        </span>
                    </template>
                    <template #cell(status)="{item}">
                        <span v-if="item.status === 1">
                          Ochilmoqda
                        </span>

                                    <span v-if="item.status === 2">
                          Ochiq
                        </span>

                                    <span v-if="item.status === 3">
                          {{ $t('messageStatus.waterRound3') }}
                        </span>

                                    <span v-if="item.status === 4">
                          Yopilmoqda
                        </span>

                                    <span v-if="item.status === 5">
                          Yopilgan
                        </span>
                                    <span v-if="item.status === 6">
                          {{ $t('messageStatus.waterRound6') }}
                        </span>
                    </template>
                    <template #cell(actions)="{item}">
                        <b-button
                            v-if="item.debt_payments.length !== 0"
                            variant="warning"
                            size="sm"
                            @click="handleOpenPayStatus(item)"
                        >
                            <i class='bx bx-dollar fs-4'></i>
                        </b-button>

                        <b-button
                            v-if="item.driver_debt !== 0"
                            variant="danger"
                            size="sm"
                            @click="handlePayDebt(item)"
                        >
                            <i class='bx bxs-wallet fs-4'></i>
                        </b-button>


                        <b-button
                            v-if="item.status === 1"
                            class="ms-1"
                            variant="success"
                            size="sm"
                            @click="actionModalPut(item.id)"
                        >
                            <i class="bx bx-pencil fs-4"></i>
                        </b-button>

                        <b-button
                            v-if="item.status === 2 || item.status === 6"
                            variant="success"
                            size="sm"
                            @click="actionModalFinish(item)"
                        >
                            <i class="bx bx-list-check fs-4"></i>
                        </b-button>
                      <b-button variant="primary" size="sm" @click="handleOpenPayStatus(item)">
                        <i class="bx bx-error-alt fs-4"></i>
                      </b-button>

                        <!-- <b-button
                          class="ms-1"
                          variant="danger"
                          size="sm"
                          @click="deleteModalOpen(item.id)"
                        >
                          <i class="bx bx-trash-alt fs-4"></i>
                        </b-button> -->
                    </template>
                </b-table>
            </div>
        </div>

        <div class="col-12">
            <b-pagination
                v-model="pagination.page"
                :total-rows="fetch.total"
                :per-page="pagination.pageSize"
                @input="fetchData(pagination)"
            ></b-pagination>
        </div>
        <b-modal
            v-model="actionModal"
            hide-footer
            hide-header
            no-close-on-backdrop
            no-close-on-esc
        >
            <ActionsModal
                :id="id"
                :driverOptions="driverOptions"
                :productsOptions="productsOptions"
                @onClose="actionModalClose"
            />
        </b-modal>
        <b-modal
            v-model="deleteModal"
            hide-footer
            hide-header
            no-close-on-backdrop
            no-close-on-esc
        >
            <DeleteModal
                :id="id"
                @onClose="deleteModalClose"
            />
        </b-modal>
        <b-modal
            v-model="finishModal"
            hide-footer
            hide-header
            no-close-on-backdrop
            no-close-on-esc
        >
            <FinishModal
                :finishOptions="finishOptions"
                :productsOptions="productsOptions"
                :showProductOptions="showProductOptions"
                :productPrice="productPrice"
                :showMangerWaterDetails="showMangerWaterDetails"
                @onClose="finishModalClose"
            />
        </b-modal>
        <b-modal
            v-model="modalPay"
            hide-footer
            hide-header
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="container">
                <ValidationObserver v-slot="{handleSubmit}">
                    <form @submit.prevent="handleSubmit(onSubmit)">
                        <label>
                            {{ $t('modal.form.set_driver_money') }}
                            <p class="title mb-0">
                                {{ totalSum }}
                            </p>
                        </label>

                        <ValidationProvider
                            :name="$t('modal.form.debt')"
                            rules="required|min:3"
                            v-slot="{ errors }"
                        >
                            <label>
                                {{ $t('modal.form.debt') }}
                                <input
                                    v-model="form.debt"
                                    type="number"
                                    :max="totalSum"
                                    :placeholder="$t('modal.form.debt')"
                                >
                                <span class="text-danger">{{ errors[0] }}</span>
                            </label>
                        </ValidationProvider>

                        <label>
                            {{ $t('modal.form.debt_driver_money') }}
                            <p class="title mb-0">
                                {{ debtSum }}
                            </p>
                        </label>

                        <div class="w-100 d-flex gap-2 justify-content-end">
                            <b-button
                                variant="warning"
                                @click="handlePayDebtClose"
                            >
                                {{ $t('modal.button.back') }}
                            </b-button>

                            <b-button
                                variant="primary"
                                type="submit"
                                :disabled="db"
                            >
                                {{ $t('modal.button.pay') }}
                            </b-button>
                        </div>
                    </form>
                </ValidationObserver>
            </div>
        </b-modal>
        <b-modal
            v-model="payModal"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            hide-header
        >
            <div class="container" v-if="payObj !== null">
                <h5>
                    {{ $t('modal.form.driver.label') }}: <b>{{ payObj.driver.full_name }}</b>
                </h5>
                <h5>
                    REYS: {{ payObj.name }}
                </h5>
              <h5>Suvlar soni: {{payObj.total_products_quantity}}</h5>
              <h5>Bo'sh taralar soni: {{payObj.empty_tara}}</h5>
              <h5>Yangi Shartnomalar: {{payObj.new_contracts_bottles_quantity}}</h5>
              <h5 class="text-primary">Qo'shimcha berilgan: {{payObj.extra_tara_count}}</h5>
              <h5 class="text-danger">{{$t('modal.form.get_tara_count')}}: {{payObj.returned_client_products}}</h5>
              <h5>Qaytgan suvlar soni: {{payObj.returned_products_count}}</h5>
              <h5>{{$t('data.allSum')}} {{parseInt(payObj.money_paid_by_driver) + parseInt(payObj.driver_debt)}}</h5>
              <h5>To'langan summa: {{payObj.money_paid_by_driver}}</h5>
              <h5>{{$t('modal.form.debt_driver_money')}}: {{payObj.driver_debt}}</h5>


                <div>
                    <div
                        class="d-flex w-100 justify-content-between my-1"
                        v-for="(obj, index) in payObj.debt_payments"
                        :key="index"
                    >
                        <div class="w-100"
                             :class="obj.status_id === 3 ? 'text-danger' : ''"
                        >
                            <div>
                                <span>{{ $t('modal.form.debt') }}</span>: <b>{{ obj.price }}</b>
                            </div>

                            <div>
                                {{ $t('modal.form.data') }}: <b>{{ obj.created_at | DayStartDate(obj.created_at) }}</b>
                            </div>
                        </div>

                        <div>
                            <div
                                v-if="obj.status_id === 1"
                                class="animate text-warning fs-4"
                            >
                                <i class='bx bx-loader'></i>
                            </div>

                            <div
                                v-if="obj.status_id === 2"
                                class="text-success fs-4"
                            >
                                <i class='bx bx-check'></i>
                            </div>

                            <div
                                v-if="obj.status_id === 3"
                                class="text-danger fs-4"
                            >
                                <i class='bx bx-x'></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w-100 d-flex justify-content-end align-items-center gap-2 mt-2">
                    <b-button
                        variant="warning"
                        @click="handlePayModalClose"
                    >
                        {{ $t('modal.button.back') }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ActionsModal from './components/ActionsModal.vue';
import DeleteModal from './components/DeleteModal.vue';
import FinishModal from './components/FinishModal.vue'
import {getDriver} from '../../../api/endpoints/users';
import {getInfoAll, getInfoByID} from '../../../api/endpoints/products';
import {showManagerWaterRound, getManagerWaterRound} from '../../../api/endpoints/managerWaterRound';
import {isPayDebt} from '../../../api/endpoints/driverWaterRounds';
import {getActiveRounds} from '@/api/endpoints/active-rounds';
import moment from "moment";

export default {
    name: "MangerWaterRound",
    components: {
        ActionsModal,
        DeleteModal,
        FinishModal
    },
    filters:{
      momentDate(date) {
          return moment(date).add(2, 'hours').format('DD-MM-YYYY HH:mm')
      }
    },
    data() {
        return {
            fields: [
                {key: "id", label: "№"},
                {key: "created_at", label: this.$t('modal.form.data')},
                {key: "name", label: 'REYS'},
                {key: "driver.full_name", label: this.$t('table.driver.label')},
                {key: "status", lable: this.$t('table.status.label')},
                {key: "total_products_quantity", label: this.$t('table.total_products_quantity')},
                {key: "driver_debt", label: this.$t('modal.form.debt_driver_money')},
                {key: "actions", label: this.$t('table.actions.label')}
            ],
            actionModal: false,
            deleteModal: false,
            finishModal: false,
            id: null,
            finish: false,
            driverOptions: [],
            productsOptions: [],
            finishOptions: {},
            productShowOptions: {},
            showMangerWaterDetails: {},
            productPrice: null,
            showProductOptions: {},
            pagination: {
                page: 1,
                pageSize: 20,
                driver_id: null,
                date: this.nowDate(),
            },
            modalPay: false,
            form: {
                debt: null
            },
            totalSum: null,
            sum: 0,
            debtInfo: {},
            debtId: null,
            payModal: false,
            payObj: null,
            driver: {
                filter: [],
                bottles_count: null,
            },
            fetch: {
                items: [],
                total: 1,
                loading: false
            },
            db: false,
            round: {
                items: {},
                isHave: 0,
                inOrder: 0,
            }
        }
    },
    mounted() {
        this.fetchData();
        this.getDriverOptions();
    },
    computed: {
        debtSum() {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.sum = 0
            if (this.form.debt) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.sum += parseInt(this.form.debt)
            }

            return this.totalSum - this.sum
        }
    },
    methods: {
        actionModalPut(id) {
            this.id = id;
            this.actionModal = true;
            this.getProductsOptions();
        },
        actionModalPost() {
            this.id = null
            this.actionModal = true;
            this.getProductsOptions();
        },
        actionModalClose() {
            this.actionModal = false;
            this.fetchData();
            this.id = null;
        },
        actionModalFinish(item) {
            this.finishOptions = item;
            this.finishModal = true;
            this.getProductsOptions();
            this.showMangerWater(item.id);
        },
        finishModalClose() {
            this.fetchData();
            this.finishModal = false;
        },
        goToProduct(id) {
            this.$router.push('/manager/water-round/' + id)
        },
        getDriverOptions() {
            getDriver().then(res => {
                this.driverOptions = res.data.data.map(item => Object.assign({}, {
                    value: item.id,
                    label: item.full_name
                }));
                this.driver.filter = res.data.data;
            })
        },
        getProductsOptions() {
            getInfoAll().then(res => {
                this.productsOptions = res.data.data.map(item => Object.assign({}, {value: item.id, label: item.name}))
            })
        },
        deleteModalOpen(id) {
            this.id = id;
            this.deleteModal = true;
        },
        deleteModalClose() {
            this.id = null;
            this.deleteModal = false;
            this.fetchData();
        },
        showMangerWater(id) {
            showManagerWaterRound(id).then(res => {
                this.showMangerWaterDetails = res.data.data;
                let productId = res.data.data.products[0].id
                getInfoByID(productId).then(res => {
                    this.showProductOptions = res.data.data;
                    this.productPrice = res.data.data.stock[0].price
                })

            })
        },
        handlePayDebt(item) {
            this.debtInfo = item;
            this.modalPay = true;
            this.totalSum = item.driver_debt;
            this.debtId = item.id;
        },
        handlePayDebtClose() {
            this.modalPay = false;
            this.totalSum = null;
            this.debtId = null;
        },
        onSubmit() {
            this.db = true;
            setTimeout(() => {
                this.db = false;
            }, 700)
            let temp = {round_id: this.debtId, amount: this.form.debt};
            isPayDebt(temp).then(() => {
                this.fetchData();
                this.handlePayDebtClose();
                this.form.debt = null
            })
        },
        handleOpenPayStatus(item) {
            this.payModal = true;
            this.payObj = item;
        },
        handlePayModalClose() {
            this.payModal = false;
            this.payObj = null;
        },
        fetchData() {
            this.fetch.loading = true;
            getManagerWaterRound(this.pagination)
            .then(response => {
                this.fetch.items = response.data.data;
                this.fetch.total = response.data.total;
                if (this.pagination.driver_id !== null) {
                    let count = this.fetch.items.filter(val => val.status == 2)
                    if (count.length !== 0) {
                        this.driver.bottles_count = count[0].total_products_quantity;
                    }
                    if (this.driver.bottles_count == undefined) {
                        this.driver.bottles_count = this.$t('data.notWater')
                    }
                }
            })
            .catch(err => {
                // eslint-disable-next-line no-console
                console.log(err);
            })
            .finally(() => {
                this.fetch.loading = false;
            })
        },
        nowDate() {
            return moment(new Date()).format('YYYY-MM-DD')
        },
        fetchActiveRound() {
            this.round.items = []
            this.round.inOrder = 0
            this.round.isHave = 0
            getActiveRounds({driver_id: this.pagination.driver_id})
            .then(responsive => {
                let res = responsive.data.data
                this.round.items = res;
                if(res) {
                    this.round.inOrder = res.orders.map(el => el.count).reduce((a, b) => a + b, 0);
                    this.round.isHave = res.total_products_quantity - this.round.inOrder
                } else {
                    this.round.isHave = this.$t('dispatcher.clients.errorMessage')
                }
            })
        },
        tableRow(item, type) {
            if (!item || type !== 'row') return ""
            if (item.driver_id) {
                if (item.status == 3) return 'table-danger'
                if (item.status == 4) return 'table-warning'
            }
        },
    },

}
</script>

<style lang="scss">
.animate {
    animation: kanime 2s infinite linear;
    @keyframes kanime {
        0% {
            transform: rotate(0);
        }

        100% {
            transform: rotate(360deg);
        }
    }
}

.filter-input {
    width: 100%;
    border-radius: 4px;
    line-height: 1.4;
    font-size: 1em;
    border: 1px solid;
    border-color: rgba(60, 60, 60, 0.26);
    outline: none;
    padding: 5px 7px;
}

.filter-select {
    background: #fff;
}
</style>
